export default {
  models: {
    asset: 'Activo | Activo | Activos', // zero, one, many
    emo: 'EMO | EMO | EMOs',
    image: 'Imagen | Imagen | Imágenes',
    level: 'Nivel | Nivel | Niveles',
    location: 'Ubicación | Ubicación | Ubicaciones',
    meter: 'Medidor | Medidor | Medidores',
    note: 'Nota | Nota | Notas',
    site: 'Sitio | Sitio | Sitios'
  },
  attributes: {
    desc: "Descripción",
    description: "Descripción",
    energy_source: "Fuente de energía",
    energy_source_id: "Fuente de energía",
    lat: "Latitud",
    long: "Longitud",
    area: "Superficie del piso",
    area_unit: "Unidad de área",
    location_uuid: "Ubicación",
    asset: {
      asset_sub_type: "Subtipo de activo",
      description: "Descripción",
      energy_source: "Fuente de energía",
      energy_source_id: "Fuente de energía",
      energy_use_cat: "Categoría de uso de energía",
      energy_use_cat_id: "Categoría de uso de energía",
      energy_use_sub_cat: "Categoría de uso de energía",
      name: "Nombre del activo",
      location: "Ubicación",
      qty: "Cant.",
      installed_on: "Instalado",
      retired_on: "Retirado",
      life_cycle_length: "Duración del ciclo de vida",
      manufacturer: "Fabricante",
      meter: "Medidor",
      meter_uuid: "Medidor",
      model_num: "N º de Modelo.",
      controls: "Controles",
      local_control: "Local",
      central_control: "Central",
      manual_control: "Manual",
      none_control: "Nada",
      power_cal_method: "Método de cálculo de potencia",
      rated_input_power: "Potencia nominal de entrada",
      rated_input_power_unit: "Unidad de potencia de entrada nominal",
      rated_input_power_unit_code: "Unidad de potencia de entrada nominal",
      rated_input_power_unit_id: "Unidad de potencia de entrada nominal",
      rated_output_power: "potencia de salida nominal",
      rated_output_power_unit: "unidad de potencia de salida nominal",
      rated_output_power_unit_code: "unidad de potencia de salida nominal",
      rated_output_power_unit_id: "unidad de potencia de salida nominal",
      rated_efficiency_pcn: "Eficiencia nominal",
      serial_num: "Número de serie.",
      tag: "Etiqueta de activo"
    },
    emo: {
      name: "Nombre de OGE",
      description: "Descripción",
      location: "Ubicación",
      asset: "Activo",
      owner: "Relacionado con",
      owner_type: "Relacionado con tipo",
      energy_change: "Cambio de energía",
      energy_unit: "Unidad de Energía",
      energy_use_cat: "Categoría de uso de energía",
      energy_use_sub_cat: "Subcategoría de uso de energía",
      energy_source: "Fuente de energía",
      energy_source_id: "Fuente de energía",
      emo_category: "Categoría OGE",
      saving_method: "Método de ahorro",
      saving_accuracy: "Precisión de ahorro",
      saving_pcn: "Porcentaje de ahorro",
      replacement: "Reemplazo",
      operational: "Operacional",
      administrative: "Administrativo",
      maintenance: "Mantenimiento",
      modification: "Modificación",      
      annual_saving_persistence: "Persistencia del ahorro anual"
    },
    location: {
      name: "Nombre del lugar",
      parent: "Parte del",
      building_name: "Edificio",
      area_name: "Área",
      level_name: "Nivel",
      location_name: "Ubicación",
      description: "Descripción",
      area: "Superficie del piso",
      area_unit: "Unidad de área"
    },
    meter: {
      num: "Nº de medidor",
      multiplier: "Multiplicador",
      serial_no: "No. de serie",
      type: "Meter Tipo",
      unit_of_measure: "Unidad de medida"
    },   
    note: {
      title: "Título",
      details: "Detalles",
      owner: "Relacionada con",
      owner_type: "Relacionada con tipa"
    },   
    site: {
      name: "Nombre del sitio",
      company: "Organización",
      desc: "Descripción",
      address: "Dirección",
      city: "Ciudad",
      province: "Provincia",
      post_code: "Código postal",
      country: "País",
      primary_function: "Función primaria",
      site_function: "Sitio Función Observaciones",
      area: "Superficie total del suelo",
      area_unit: "Unidad de área",
      year_built: "Año de construcción",
      nb_floors: "Nº de pisos",
      nb_buildings: "Nº de edificios",
      occupancy_pcn: "Ocupación",
      weekly_op_hours: "Horas de operación semanales",
      lat: "Latitud",
      long: "Longitud"
    }
  },
  errors: {
    site: {
      no_company: "Sitio no vinculado a una organización.",
      print_pdf: "Error al imprimir PDF",   
      sync_site: "Error en la sinc del sitio"   
    },
    save_image: "Problema al guardar imagen"   
  },
  add: "Agregar",
  add_annotation: "Agregar anotación", 
  aims_login: "Iniciar sesión AIMS",
  all_sync_done: "La sinc de los datos del sitio se completó con éxito", 
  are_you_sure: "¿Estas seguro?",
  back: "Atrás",
  binding_instance: "Vinculación a una nueva instancia de AIMS",
  binding_instance_confirm: "La vinculación a una nueva instancia borrará todos los datos de la instancia actual. ¿Está seguro de que desea continuar?",
  cancel: "Cancelar",
  clear_annotations: "Borrar anotaciones", 
  clear_data: "Borrar datos de la aplicación",
  cleared_all_assets: "Borró todos los activos.",
  completed: "Terminado",
  confirm_update_version: "¡Nueva versión de AIMS2GO disponible! ¿Actualizar ahora?",
  confirm_overwrite_geo: "Lat/Long ya existe. ¿Confirmar sobrescribir valores existentes?",
  current_instance: "Instancia AIMS actual",
  delete: "Borrar",
  delete_object: "Borrar {object}", 
  deleted_on_aims: "Eliminado en AIMS",
  downloaded: "Descargado",
  edit: "Editar",
  energy_meter: "Medidor de energía",
  english: "English",
  export_to_excel_done: "Exportación a Excel completada", 
  filter: "Filtro",
  home: "Inicio",
  gallery: "Gallery", 
  geo_location: "Ubicación geográfica",
  geo_location_success: "Ubicación geográfica actualizada",
  geo_location_error: "Error al obtener la ubicación geográfica",
  import_done: "Importación realizada", 
  import_sites: "Importar sitios",
  imported: "Importado",
  in_progress: "En curso",
  list_sites: "Listar sitios",
  language: "Idioma", 
  login: "Iniciar sesión",
  login_successful: "Inicio de sesión exitoso",
  login_failed: "Error de inicio de sesion",
  logout: "Cerrar sesión",
  map: "Mapa",
  new: "Nuevo",
  new_instance: "Nueva instancia de AIMS",
  new_object: "Nuevo {object}",
  no: "No",
  open_map_app: "Abrir aplicación de mapa",
  pending: "Pendiente",
  retake: "Volver a tomar",
  select_file: "Seleccione Archivo",
  settings: "Configuraciones",
  spanish: "Español",
  submit: 'Enviar',
  sync: "Sinc",
  take_photo: "Tomar foto",
  updated: "Actualizado",
  uploaded: "subido",
  use_photo: "Usar foto",
  water_meter: "Medidor de agua",
  years: "Años",
  yes: "Sí"
}